let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("yK3zL")).then(() => parcelRequire('4R9ta'));